import React, { Component } from "react";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";
import { withRouter } from 'react-router-dom';

import Spinner from "@sm/components/Spinner";
import Table from "@sm/components/custom/Table";

import "@assets/css/apiData.css";

import * as actions from "@sm/actions";
import { DASHBOARD_PAYOUT_BALANCES } from "@sm/actions/types";
import { toFormattedNumber } from "@sm/utils/utils";
import { DATA_TYPES } from "@modules/data/ManualInput";
const store = require("@sm/reducers/index");

class DashBoardPayoutBalancesComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      balances: [],
      loading: true,
      socket: false,

      columns: [
        {
          value: "currency",
          label: "Currency",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "merchant",
          label: "Merchant",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "mid",
          label: "MID",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "tags",
          label: "Tags",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "lastPayout",
          label: "Last Payout",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "provider",
          label: "Provider",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "availableBalance",
          label: "Available Balance",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "pendingPayouts",
          label: "Pending Payouts",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "payoutBalance",
          label: "Payout Balance",
          rightAligned: true,
          className: "btn view-settlement",
          isButton: true,
          triggerEvent: (data) => this.viewTopUp(data),
          isButtonDisabled: () => { return false; },
          isButtonLoading: () => { return false; }
        },
      ],
    };
  }

  subscribeFunction = null;

  componentDidMount() {
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true
        });
      }

      if (state.update === DASHBOARD_PAYOUT_BALANCES && this.props.thisMonth) {
        this.setState({
          balances: state.balances,
          loading: false,
        });
        return;
      }

      if (state.update === DASHBOARD_PAYOUT_BALANCES) {
        this.setState({
          balances: state.balances,
          loading: false,
        });
      }
    });
  };

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  viewTopUp = (data) => {
    this.props.history.push({
      pathname: "/manual-input",
      state: { ...data, dataType: DATA_TYPES.TOP_UP_PAYOUT_WALLET }
    });
  };

  tableData = () => {
    const { balances } = this.state;

    if (!balances) {
      return [];
    }

    return balances.map((elem) => {
      return {
        currency: elem.currency,
        merchant: elem.merchant,
        merchantId: elem.merchantId,
        mid: elem.mid,
        tags: elem.tags,
        lastPayout: elem.lastPayout,
        provider: elem.provider,
        providerId: elem.providerId,
        availableBalance: toFormattedNumber(elem.availableBalance),
        pendingPayouts: toFormattedNumber(elem.pendingPayouts),
        payoutBalance: toFormattedNumber(elem.payoutBalance)
      };
    });
  };

  render() {
    const {
      columns,
      loading,
    } = this.state;
    
    return (
      <>
        <Panel style={ { height: "100%" } }>
          <Panel.Heading>
            <Panel.Title> PAYOUT BALANCES </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            {loading ? (
              <Spinner smallContainer={ true } />
            ) : (
              <div className="panel-content table-content">
                <Table
                  columns={ columns }
                  className="payout-alerts"
                  headerColor={ "#DFDFDF" }
                  defaultSortBy={ "currency" }
                  data={ this.tableData() }
                  isStriped={ false }
                />
              </div>
            )}
          </Panel.Body>
        </Panel>
      </>
      
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default withRouter(connect(mapStateToProps, actions)(DashBoardPayoutBalancesComponent));
